import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllRoadObjectsLayer } from "../../../../widgets/map/mapFeatures/layers";
import MapWidget from "../../../../widgets/map/mapWidget/MapWidget";
import { MapOverlayWidget } from "../../../../widgets/map/mapAddons/mapOverlayWidget";
import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";
import { useMapURLParams } from "../../../../hooks/map/useMapParams";
import { MapName } from "../../../../stateManagement/reducers/maps/actions";
import { useMapSlice } from "../../../../stateManagement/hooks/useMapSlice";
import { useAuthWeatherStationsService } from "../../../../hooks/auth/useAuthWeatherStationsService";
import { useWeatherStations } from "../../../../hooks/data/useWeatherStations";
import { useWeatherStationsMapLayer } from "../../../../hooks/map/layers/useWeatherStationsMapLayer";
import { getObjectsOnMapPoint } from "../../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";

export function MapWeatherStations() {
    const navigate = useNavigate()
    const { mapName } = useMapURLParams() as { mapName: MapName; mapOption?: string };
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const mapState = useMapSlice(mapName)

    const roadsLayer = getAllRoadObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useAuthWeatherStationsService();
    const { weatherStations, isFetching } = useWeatherStations()
    const weatherStationsLayer = useWeatherStationsMapLayer(weatherStations);

    useEffect(() => {
        if (weatherStationsLayer) {
            setAdditionalLayers([weatherStationsLayer])
        }
    }, [weatherStationsLayer])

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnMapPoint(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "objectsFindAlways",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title="Метеостанции" objectTypeName={mapName} type="map" />
            <div className="map-widget-with-toast">
                <MapWidget
                    additionalLayers={additionalLayers}
                    permanentLayers={permanentLayers}
                    mapEventHandlers={mapEventHandlers}
                />
                <MapOverlayWidget />
            </div>
        </>
    )
}
